import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import apiClient from '../api/client';
import Modal from '../components/Modal';
import './ProdutosBar.css';

/**
 * Página para Admin gerenciar produtos do bar
 */

const ProdutosBar = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [produtoEditando, setProdutoEditando] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    preco: '',
    ativo: true,
  });

  useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    carregarProdutos();
  }, [isAdmin, navigate]);

  const carregarProdutos = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await apiClient.get('/produtos-bar/todos');
      setProdutos(Array.isArray(response.data) ? response.data : []);

    } catch (err) {
      console.error('Erro ao carregar produtos:', err);
      setError(err.response?.data?.error || 'Erro ao carregar produtos');
    } finally {
      setLoading(false);
    }
  };

  const handleAbrirModal = (produto = null) => {
    if (produto) {
      setProdutoEditando(produto);
      setFormData({
        nome: produto.nome,
        preco: parseFloat(produto.preco).toFixed(2),
        ativo: produto.ativo,
      });
    } else {
      setProdutoEditando(null);
      setFormData({
        nome: '',
        preco: '',
        ativo: true,
      });
    }
    setShowModal(true);
  };

  const handleFecharModal = () => {
    setShowModal(false);
    setProdutoEditando(null);
    setFormData({
      nome: '',
      preco: '',
      ativo: true,
    });
  };

  const handleSalvar = async (e) => {
    e.preventDefault();

    if (!formData.nome || !formData.preco) {
      setError('Nome e preço são obrigatórios');
      return;
    }

    try {
      setError('');

      if (produtoEditando) {
        // Atualizar
        await apiClient.put(`/produtos-bar/${produtoEditando.id}`, formData);
        alert('Produto atualizado com sucesso!');
      } else {
        // Criar
        await apiClient.post('/produtos-bar', formData);
        alert('Produto criado com sucesso!');
      }

      handleFecharModal();
      carregarProdutos();
    } catch (err) {
      console.error('Erro ao salvar produto:', err);
      setError(err.response?.data?.error || 'Erro ao salvar produto');
    }
  };

  const handleInativar = async (produtoId) => {
    if (!window.confirm('Deseja inativar este produto?')) {
      return;
    }

    try {
      await apiClient.delete(`/produtos-bar/${produtoId}`);
      alert('Produto inativado com sucesso!');
      carregarProdutos();
    } catch (err) {
      console.error('Erro ao inativar produto:', err);
      setError(err.response?.data?.error || 'Erro ao inativar produto');
    }
  };

  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  const produtosAtivos = produtos.filter(p => p.ativo);
  const produtosInativos = produtos.filter(p => !p.ativo);

  return (
    <div className="container produtos-bar-container">
      <div className="page-header">
        <h1>🍺 Gerenciar Produtos do Bar</h1>
        <div>
          <button onClick={() => navigate('/admin/menu')} className="btn btn-secondary">
            ← Voltar
          </button>
          <button onClick={() => handleAbrirModal()} className="btn btn-primary" style={{ marginLeft: '10px' }}>
            + Novo Produto
          </button>
        </div>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="produtos-section">
        <h2>Produtos Ativos ({produtosAtivos.length})</h2>
        {produtosAtivos.length > 0 ? (
          <div className="produtos-grid">
            {produtosAtivos.map(produto => (
              <div key={produto.id} className="produto-card ativo">
                <div className="produto-info">
                  <h3>{produto.nome}</h3>
                  <p className="produto-preco">R$ {parseFloat(produto.preco).toFixed(2)}</p>
                </div>
                <div className="produto-actions">
                  <button
                    onClick={() => handleAbrirModal(produto)}
                    className="btn btn-primary btn-sm"
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => handleInativar(produto.id)}
                    className="btn btn-danger btn-sm"
                  >
                    Inativar
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="sem-produtos">Nenhum produto ativo cadastrado.</p>
        )}
      </div>

      {produtosInativos.length > 0 && (
        <div className="produtos-section">
          <h2>Produtos Inativos ({produtosInativos.length})</h2>
          <div className="produtos-grid">
            {produtosInativos.map(produto => (
              <div key={produto.id} className="produto-card inativo">
                <div className="produto-info">
                  <h3>{produto.nome}</h3>
                  <p className="produto-preco">R$ {parseFloat(produto.preco).toFixed(2)}</p>
                  <span className="badge-inativo">Inativo</span>
                </div>
                <div className="produto-actions">
                  <button
                    onClick={() => handleAbrirModal(produto)}
                    className="btn btn-primary btn-sm"
                  >
                    Editar
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <Modal isOpen={showModal} onClose={handleFecharModal} title={produtoEditando ? 'Editar Produto' : 'Novo Produto'}>
        <form onSubmit={handleSalvar}>
          <div className="form-group">
            <label>Nome do Produto *</label>
            <input
              type="text"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              required
              placeholder="Ex: Cerveja, Refrigerante, Água..."
            />
          </div>

          <div className="form-group">
            <label>Preço (R$) *</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={formData.preco}
              onChange={(e) => setFormData({ ...formData, preco: e.target.value })}
              required
              placeholder="0.00"
            />
          </div>

          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.ativo}
                onChange={(e) => setFormData({ ...formData, ativo: e.target.checked })}
              />
              {' '}Produto Ativo
            </label>
            <small>Produtos inativos não aparecem na lista ao lançar consumos</small>
          </div>

          <div className="form-actions">
            <button type="button" onClick={handleFecharModal} className="btn btn-secondary">
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              {produtoEditando ? 'Atualizar' : 'Criar'}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default ProdutosBar;
